import { ButtonProps } from '@slite/components'
import { FormButton } from './FormButton'
import { Label } from './Label'
import { Error } from './Error'

export type LabelProps = {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}
export type ErrorProps = {
  message?: string | undefined
  className?: string
  style?: React.CSSProperties
  render?: (message: string) => React.ReactNode
}
export const isString = (
  children: ButtonProps['children']
): children is string => {
  return typeof children === 'string'
}

export const Form = {
  Label,
  Error,
  Button: FormButton,
}
